<template>
<p class="Polaris-Caption">
    <slot></slot>
</p>
</template>

<script>
export default {
};
</script>


// WEBPACK FOOTER //
// src/components/PolarisCaption.vue?2790d336